<template>
  <BushelAlert alert-class="alert-warning mb-0 rounded-0" main-content-class="w-100" :show-icon="false">
    <div class="d-flex align-items-center justify-content-center flex-wrap text-center">
      <span>
        <i class="fas fa-eye-slash mr-1" />
        You've disabled {{ company.name }}. You can browse their menu, but ordering is off until you enable them.
      </span>
      <BushelBtn v-if="canEnable" variant="primary" class="btn-sm ml-3" :loading="enabling" @click="enable"> Enable Vendor </BushelBtn>
      <span v-else class="text-muted ml-1">Someone with vendor permissions can enable them.</span>
      <span v-if="failed" class="text-danger small w-100 mt-1">Couldn't enable this vendor. Please try again.</span>
    </div>
  </BushelAlert>
</template>

<script>
import { mapState } from "vuex";
import { userCan } from "@/services/helpers";
import * as api from "@/services/api";

export default {
  name: "VendorDisabledAlert",
  props: {
    company: { type: Object, required: true },
  },
  emits: ["enabled"],
  data() {
    return {
      enabling: false,
      failed: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    canEnable() {
      return userCan("update vendors", this.user);
    },
  },
  methods: {
    async enable() {
      this.enabling = true;
      this.failed = false;
      try {
        await api.patch(`/vendors/company/${this.company.uuid}/disabled`, { vendor_disabled: false });
        this.$emit("enabled");
      } catch {
        this.failed = true;
      } finally {
        this.enabling = false;
      }
    },
  },
};
</script>
